import React, { forwardRef } from "react";
import { Link } from 'react-router-dom';
import { MDBDataTableV5 } from "mdbreact";
import moment from "moment";
import Tooltip from "react-simple-tooltip"

const DataTablesProject = forwardRef((props, ref) => {
	let data = props.data;
	let finalData = [];

	if (data) {
		for (var index = 0; index < data.length; index++) {
			let rowItem = {};
			rowItem["id"] = data[index].id;
			rowItem["is_shortcuts"] = data[index].is_in_shortcuts;
			rowItem["job_number"] = <><Link to={`/schedule-details/${data[index].id}`}>{data[index].job_number}</Link> <span className="ml-2" onClick={() => props.changeStatus(rowItem)}> {data[index]?.is_in_shortcuts ? <Tooltip content="Remove from shortcut" background="#fa7a13" color="#fff" border="0" padding={8}><i className="fa fa-thumb-tack"></i></Tooltip> : <Tooltip padding={8} content="Add to shortcut" color="#fff" border="0" background="#fa7a13"><i className="icon-pin"></i> </Tooltip> }</span> </>;
			// rowItem["job_number"] = <><Link to={`/schedule-details/${data[index].id}`}>{data[index].job_number}</Link> { data[index].is_in_shortcuts ?  : <Tooltip content="Add to shortcut"><i className="icon-pin"></i> </Tooltip> } </>;
			rowItem["title"] = data[index].title;
			rowItem["agency_name"] = data[index].agency_name ? data[index].agency_name.substring(0,20) : data[index].partner_name;
			rowItem["startDate"] =  moment(data[index].project_start_date).format('DD/MM/YYYY');
			rowItem["createdAt"] =  moment(data[index].project_end_date).format('DD/MM/YYYY');
			rowItem["status"] = <span className="bg_new_status">{data[index].project_status}</span>;
      rowItem["editButton"] = <Link className="btn custom-btn-outline-info" to={`/project/${data[index].id}`}><i className="fa fa-edit"></i></Link>;

		  finalData.push(rowItem);
		}
		//console.log("final data", finalData);
	}
	
//const [datatable, setDatatable] = React.useState({
const datatable = {  
  columns: [
      {
        label: 'Job Number',
        field: 'job_number',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Task Title',
        field: 'title',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Start Date',
        field: 'startDate',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Due Date',
        field: 'createdAt',
        sort: 'asc',
        width: 150
      },
	    {
        label: 'Status',
        field: 'status',
        width: 150,
		    sort: 'asc'
      } ,
      {
        label: '',
        field: 'editButton',
        width: 150,
		    sort: 'disabled'
      } 
    ],
    rows: finalData 
	};
  return (
    <MDBDataTableV5 
	   id="mdbDtTable"
        hover
        bordered
        small
        sortable={false}
        striped
        entriesOptions={[5, 10 ,20, 25]} 
        entries={5} 
        pagesAmount={4} 
        data={datatable} 
        searchBottom={false} 
    />

  );
});

export default DataTablesProject;